import { create } from 'zustand';

// 轻量 UI 状态仓库。
// 当前只管理 newsletter 输入；未来如果增加菜单开合、主题、弹窗状态，可以继续放在这里。
export const useUiStore = create((set) => ({
  newsletterEmail: '',
  setNewsletterEmail: (newsletterEmail) => set({ newsletterEmail }),
  resetNewsletter: () => set({ newsletterEmail: '' })
}));
